import classNames from 'classnames';
import React from 'react';
import { Button, Image, OverlayTrigger, Popover } from 'react-bootstrap';
import { OverlayTriggerType } from 'react-bootstrap/esm/OverlayTrigger';

export interface IActionButtonProps
  extends React.HTMLAttributes<HTMLButtonElement> {
  iconclass?: string;
  text: string;
  disabled?: boolean;
  src?: string | undefined;
  srcclass?: string | undefined;
  trigger?: OverlayTriggerType;
  rootClose?: boolean;
  overlayText?: string;
}

export const ActionButton = (props: IActionButtonProps) => {
  const { className } = props;
  return (
    <OverlayTrigger
      rootClose={props.rootClose}
      trigger={props.trigger}
      overlay={
        props.disabled && props.overlayText ? (
          <Popover style={{ padding: '0.5rem' }}>{props.overlayText}</Popover>
        ) : (
          <></>
        )
      }
    >
      <span>
        <Button
          {...props}
          className={classNames('action-button', className)}
          variant="light"
        >
          <div className="d-flex align-items-center">
            {props.iconclass && <span className={props.iconclass} />}
            {props.src && <Image src={props.src} className={props.srcclass} />}
            <div className="action-button-text">{props.text}</div>
          </div>
        </Button>
      </span>
    </OverlayTrigger>
  );
};
